<div class="data-convention-section">
  <h1 class="title">Data Convention</h1>

  @if (hasPriorConvention && currentDataConvention !== null) {
    <div class="data-convention-details">
      <div class="detail-row">
        <span class="detail-label">Dimensions order</span>
        <span class="detail-value">{{ dimensionOrderLabel(currentDataConvention.dimensionOrder) }}</span>
      </div>
      <div class="detail-row">
        <span class="detail-label">Dimension unit</span>
        <span class="detail-value">{{ currentDataConvention.dimensionUnit }}</span>
      </div>
      <div class="detail-row">
        <span class="detail-label">Weight unit</span>
        <span class="detail-value">{{ currentDataConvention.weightUnit }}</span>
      </div>
      <button
        mat-icon-button
        color="buttonSuccess"
        class="data-convention-button"
        aria-label="Update data convention"
        (click)="openDataConventionDialog()"
      >
        <mat-icon>edit</mat-icon>
      </button>
    </div>
  } @else {
    <div class="data-convention-details data-convention-example">
      <div class="detail-row">
        <span class="detail-label">Dimensions order</span>
        <span class="detail-value"></span>
      </div>
      <div class="detail-row">
        <span class="detail-label">Dimension unit</span>
        <span class="detail-value"></span>
      </div>
      <div class="detail-row">
        <span class="detail-label">Weight unit</span>
        <span class="detail-value"></span>
      </div>
      <button
        mat-stroked-button
        color="buttonSuccess"
        class="data-convention-button"
        (click)="openDataConventionDialog()"
      >
        Create
      </button>
    </div>
  }
</div>
